import { render } from "./Ingredients-add.vue?vue&type=template&id=0472a734"
import script from "./Ingredients-add.vue?vue&type=script&lang=js"
export * from "./Ingredients-add.vue?vue&type=script&lang=js"

import "./Ingredients-add.vue?vue&type=style&index=0&id=0472a734&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__